import { IconNode, Icon } from './iconQueries';
import { getMultiChoice } from './index';

export interface SortedIcons {
    byWellnessType: {
        [key: string]: {
            // the wellness type
            [key: string]: Icon[]; // the color
        };
    };
    byBlogTopic: {
        [key: string]: {
            // the blog topic
            [key: string]: Icon[]; // the color
        };
    };
}

export function iconSorter(icons: IconNode[]): SortedIcons {
    const sortedIcons: SortedIcons = { byWellnessType: {}, byBlogTopic: {} };

    for (let i = 0; i < icons.length; i++) {
        const icon = icons[i].node.elements;
        const blogTopic = getMultiChoice(icon.blog_topic);
        const wellnessType = getMultiChoice(icon.wellness_type);

        if (!blogTopic && !wellnessType) {
            continue;
        }

        const color = getMultiChoice(icon.color) || 'noColor';

        if (!!blogTopic) {
            addIcon(sortedIcons.byBlogTopic, blogTopic, color, icon);
        }

        if (!!wellnessType) {
            addIcon(sortedIcons.byWellnessType, wellnessType, color, icon);
        }
    }

    return sortedIcons;
}

// Keep each bucket's previous asset when a later icon has no usable URL.
function addIcon(
    group: SortedIcons['byBlogTopic'],
    key: string,
    color: string,
    icon: Icon
) {
    const buckets = group[key] || {};
    const withPreviousAsset = (previous?: Icon): Icon => {
        if (icon.icon_svg_file?.value?.[0]?.url?.trim()) return icon;
        if (!previous?.icon_svg_file?.value?.[0]?.url?.trim()) return icon;
        return { ...icon, icon_svg_file: previous.icon_svg_file };
    };

    group[key] = {
        ...buckets,
        [color]: [withPreviousAsset(buckets[color]?.[0])],
        all: [withPreviousAsset(buckets.all?.[0])],
    };
}
